export default __webpack_public_path__ + "static/media/electric-meter-rs485.1e12b2da.png";